<template>
  <div class="wrapper">
    <a-config-provider :locale="locale">
      <a-pagination :total="total" :show-total="total => `共${total}条`" :page-size.sync="localPageSize" :current="currentPage" show-quick-jumper @change="changePage" 
        :show-size-changer="isChangeSize" @showSizeChange="onShowSizeChange" :pageSizeOptions="pageSizeOptions"/>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: false,
      default: 10
    },
    currentPage: {
      type: Number,
      required: false,
      default: 1
    },
    isChangeSize: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data(){
    return {
      locale: zhCN,
      localPageSize: this.pageSize,
      pageSizeOptions:['10', '20', '30', '40', '50']
    }
  },
  methods: {
    changePage (page) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
      this.$emit('change', page)
    },
    onShowSizeChange (current, pageSize) {
      this.$emit('changeSize', pageSize)
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 20px;
  background: #ffffff;
  display: flex;
  justify-content: flex-end;
}
.ant-pagination{
  margin-right:35px;
}
>>> .ant-pagination-options .ant-pagination-options-size-changer{
  max-width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination.vue